'use es6';

import { FOLDER as FOLDER_IMPORT, LAYOUT as LAYOUT_IMPORT, TEMPLATE as TEMPLATE_IMPORT, CUSTOM_WIDGET as CUSTOM_WIDGET_IMPORT, GLOBAL_GROUP as GLOBAL_GROUP_IMPORT, GLOBAL_WIDGET as GLOBAL_WIDGET_IMPORT, CSS as CSS_IMPORT, JS as JS_IMPORT, THEME as THEME_IMPORT, RAW_ASSET as RAW_ASSET_IMPORT } from 'DesignData/enums/FolderAssetTypes';
export const FOLDER = FOLDER_IMPORT;
export const LAYOUT = LAYOUT_IMPORT;
export const TEMPLATE = TEMPLATE_IMPORT;
export const CUSTOM_WIDGET = CUSTOM_WIDGET_IMPORT;
export const GLOBAL_GROUP = GLOBAL_GROUP_IMPORT;
export const GLOBAL_WIDGET = GLOBAL_WIDGET_IMPORT;
export const CSS = CSS_IMPORT;
export const JS = JS_IMPORT;
export const THEME = THEME_IMPORT;
export const RAW_ASSET = RAW_ASSET_IMPORT;